export default "__VITE_ASSET__CgeIL0GC__"